<template>
  <v-container>
    
        <v-card flat>
          <form @submit.prevent="validateForm">
          <v-card-title>
            <span class="text-h5">Paciente</span>
          </v-card-title>
          <v-card-text>
            <v-container>
             
                                <v-row v-show="web_info">
                                    <v-col cols="12" md="6">
                                        
                                        <v-text-field type="text" 
                                            placeholder="Correo Electronico" name="mail"
                                            v-model="account_info.mail" ref="mail"
                                            label="*E-Mail"
                                            :error-messages="$v.account_info.mail.$error ? 'Este campo es requerido' : ''"
                                        />
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <v-text-field
                                            type="text"
                                            placeholder="Confirmar Correo Electronico"
                                            name="mail_confirm"
                                            v-model="mail_confirm"
                                            label="*Confirmar E-Mail"
                                            :error-messages="$v.mail_confirm.$dirty && !$v.mail_confirm.sameAs ? 'Los emails no coinciden' : ''"
                                        />
                                    </v-col>
                            
                                    <v-row v-show="web_info">
                                            <v-row>
                                                <v-col cols="12" md="6">
                                                    <!-- <div v-if="errors.has('account_id')" class="invalid-feedback">{{ errors.first('account_id') }}</div> -->
                                                </v-col>
                                                <v-col cols="12" md="6">
                                                    <!-- <div v-if="errors.has('mail_confirm')" class="invalid-feedback">{{ errors.first('mail_confirm') }}</div> -->
                                                </v-col>
                                            </v-row>
                                    </v-row>
                                </v-row>
                                <v-row v-show="web_info">
                                    <v-col cols="12" md="6">
                                        
                                        <v-text-field type="password"
                                            name="password" placeholder="Contraseña"
                                            label="*Contraseña"
                                            v-model="account_info.password" ref="password"
                                            :error-messages="$v.account_info.password.$error ? 'Este campo es requerido' : ''"
                                        />
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <v-text-field type="password"
                                            name="pass_confirm"
                                            placeholder="Confirmar Contraseña"
                                            label="*Confirmar Contraseña"
                                            v-model="pass_confirm"
                                            :error-messages="$v.pass_confirm.$dirty && !$v.pass_confirm.sameAs ? 'Las contraseñas no coinciden' : ''"
                                        />
                                    </v-col>
                                </v-row>
                                <v-row v-show="web_info">
                                        <v-row>
                                            <v-col cols="12" md="6">
                                                <!-- <div v-if="errors.has('password')" class="invalid-feedback">{{ errors.first('password') }}</div> -->
                                            </v-col>
                                            <v-col cols="12" md="6">
                                                <!-- <div v-if="errors.has('pass_confirm')" class="invalid-feedback">{{ errors.first('pass_confirm') }}</div> -->
                                            </v-col>
                                        </v-row>
                                </v-row>
                                <v-row>
                                   
                                       <v-col cols="12" md="6">
                                            
                                            <v-text-field  type="text" name="name"
                                                v-model="account_info.name"
                                                label="*Nombre"
                                                placeholder="Nombre"
                                                :error-messages="$v.account_info.name.$error ? 'Este campo es requerido' : ''"
                                            />
                                        </v-col>
                                        
                                        <v-col cols="12" md="6">
                                            
                                            <v-text-field type="text" name="lastname"
                                                v-model="account_info.lastname"
                                                label="*Apellido"
                                                placeholder="Apellido"
                                                :error-messages="$v.account_info.lastname.$error ? 'Este campo es requerido' : ''"
                                            />
                                        </v-col>
                                   
                                    <v-row>
                                        <v-row>
                                            <v-col cols="12" md="6">
                                                <!-- <div v-if="errors.has('name')" class="invalid-feedback">{{ errors.first('name') }}</div> -->
                                            </v-col>
                                            <v-col cols="12" md="6">
                                                <!-- <div v-if="errors.has('lastname')" class="invalid-feedback">{{ errors.first('lastname') }}</div> -->
                                            </v-col>
                                        </v-row>
                                    </v-row>
                                </v-row>
                                
                                <v-row>
                                    <v-col cols="12" md="6">
                                            
                                            <v-text-field type="text" name="DU" 
                                            v-model="account_info.dni"
                                            label="*Documento"
                                            data-vv-as="Documento"
                                            placeholder="Documento" />
                                    </v-col>

                                    <v-col cols="12" md="6">
                                        <v-label>Genero</v-label>
                                        <v-select
                                            name="gender"
                                            v-model="account_info.gender"
                                            :items="goptions"
                                            item-title="text"
                                            item-value="value"
                                            label="Género"
                                            data-vv-as="Género"
                                        />
                                    </v-col>
                                    
                                </v-row>

                                <v-row>
                                    
                                    <v-col cols="12" md="6">
                                        <v-select
                                            v-model="account_info.insuranse"
                                            :items="insuranseOptions"
                                            item-title="name"
                                            item-value="value"
                                            label="Obra Social"
                                            clearable
                                            no-data-text="No hay obras sociales disponibles"
                                        />
                                    </v-col>
                                    <v-col cols="12" md="6">
                                            
                                            <v-text-field type="date" name="dob" 
                                            v-model="account_info.dob"
                                            label="Fecha de Nacimiento"
                                            
                                            placeholder="Fecha de Nacimiento" />
                                    </v-col>

                                </v-row>

                                <v-row>
                                    <v-col cols="12" md="6">
                                        <v-text-field type="text" name="street"
                                            v-model="account_info.street"
                                            
                                            label="Direccion"
                                            placeholder="Direccion"/>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <v-text-field type="text" name="city"
                                            v-model="account_info.city"
                                            
                                            label="Ciudad"
                                            placeholder="Ciudad"/>
                                    </v-col>
                                    

                                </v-row>
                                <v-row>
                                    <v-col cols="12" md="6">
                                        <v-label>Provincia</v-label>
                                        <v-select
                                            name="province"
                                            v-model="account_info.province"
                                            :items="provincias"
                                            item-title="name"
                                            item-value="value"
                                            label="Provincia"
                                        />
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <v-text-field type="text" name="telefono"
                                            v-model="account_info.telefono"
                                            label="*Telefono"
                                            placeholder="Telefono"
                                            :error-messages="$v.account_info.telefono.$error ? 'Este campo es requerido' : ''"
                                        />
                                    </v-col>
                                </v-row>
                                <span v-show="captcha">
                                  <br>
                                  <v-row>
                                    <v-col cols="12" md="6">
                                        <div id="recaptcha"></div>
                                        <v-label for="robot" class="six columns"></v-label>
                                            <v-col cols="12" md="6">
                                            <!-- Temporarily disabled vue-recaptcha due to Vue 3 compatibility issues -->
                                            <v-checkbox
                                              v-model="account_info.robot"
                                              label="No soy un robot"
                                              :error-messages="$v.account_info.robot.$error ? 'Debe confirmar que no es un robot' : ''"
                                            ></v-checkbox>
                                            </v-col>
                                    </v-col>
                                  </v-row>
                                </span>

            </v-container>
            <small>*indica campos requeridos</small>
          </v-card-text>
          
          <v-card-actions>
            <v-spacer></v-spacer>
           
            <v-btn
              color="grey"
              dark
              @click.prevent="validateForm()"
            >
              Guardar
            </v-btn>
          </v-card-actions>
          </form>
        </v-card>
    
  </v-container>
</template>

<script>
// import VueRecaptcha from 'vue-recaptcha'; // Temporarily disabled due to Vue 3 compatibility
import { required, minLength, sameAs } from 'vuelidate/lib/validators'
import {initial_data} from "@/services/utils" 
import { getPeople, /* otros servicios que uses */ } from '@/services/monolito';

export default {
    name: "paciente",
    components: {
        // 'vue-recaptcha': VueRecaptcha, // Temporarily disabled due to Vue 3 compatibility
    },
  data: function() {
    return {
      site_key:"AIzaSyAlQ0Cw9Fbv7e3WHaLzVjbvSmNV8QPT3wc",
        auth: {
            thalamus_server: this.$default_thalamus_server,
            federation_acct: this.$store.state.credentials.fedacct,
            password: this.$store.state.credentials.password,
        },
        account_id: "",
        account_info: {
                mail:"",
                gender:"",
                name: "",
                lastname: "",
                password: "" ,
                dni: "",
                roles: ["end_user"],
                dob: "",
                active: true,
                deceased: false,
                street:"",
                subdivision:"",
                insuranse:  "",
                telefono:"",
                city:"",
                robot: false
            },
        mail_confirm: '',
        pass_confirm: '',
        dialog2: false, 
        espereDialogo: false,
        hasCaptcha: false,
        goptions: [
                    { text: 'MASCULINO', value: 'm' },
                    { text: 'FEMENINO', value: 'f' },
                    { text: 'OTRO', value: 'o' }
                ],
        insuranseOptions: [],
        provincias: [],
        web_info: true,
    }
  },
  props: ['account_info_', 'captcha', 'infoUser']
  ,

  validations() {
    return {
      account_info: {
        mail: { required },
        name: { required },
        lastname: { required },
        password: { required, minLength: minLength(6) },
        telefono: { required },
        province: {}, // Campo opcional, sin validaciones
        insuranse: {}, // Campo opcional, sin validaciones
        robot: { required }
      },
      mail_confirm: { 
        sameAs: sameAs(function () {
          return this.account_info.mail
        })
      },
      pass_confirm: { 
        sameAs: sameAs(function () {
          return this.account_info.password
        })
      }
    }
  },

  watch:{
      // Watcher para actualizar el campo de confirmación de email
      'account_info.mail'(newVal) {
        if (newVal && this.mail_confirm !== newVal) {
          // Solo actualizar si están escribiendo el email principal y los campos no coinciden

        }
      },
      
      // Watcher para actualizar el campo de confirmación de password
      'account_info.password'(newVal) {
        if (newVal && this.pass_confirm !== newVal) {
          // Si pass_confirm está vacío, asumimos que es una carga de datos o estado inicial, así que lo sincronizamos.
          if (this.pass_confirm === '') {
              this.pass_confirm = newVal;
          } else {
              // Solo loguear si el usuario está escribiendo (implícito si pass_confirm no está vacío)

          }
        }
      },
      
      /*web_info: {
            handler(val) {
                // Note: `newValue` will be equal to `oldValue` here
                // on nested mutations as long as the object itself
                // hasn't been replaced.
                // ...existing code...
                if (val)
                    this.web_info = newValue
                else
                    this.web_info = oldValue
            },
            deep: true
        },*/
      account_info_: {
            handler: async function(val){

                
                if (val && Object.keys(val).length > 0) {
                    // Usar el nuevo método para cargar los datos
                    this.loadPatientData(val);
                    
                    // Configurar web_info basado en infoUser
                    if (this.infoUser !== undefined) {
                        this.web_info = this.infoUser;
                    } else {
                        this.web_info = true;
                    }
                    
                    // Forzar la actualización del componente en el siguiente tick
                    this.$nextTick(() => {
                        this.$forceUpdate();

                    });
                }
            },
            immediate: true,
            deep: true
        },
        
        /*function(val){
            
            deep: true
        },*/
      /*captcha: function(val) {
        // ...existing code...
        if (val)
          this.hasCaptcha = val
      }*/

  },

  methods: {
        async loadPatientData(data) {

            
            // Limpiar primero
            this.account_info = {
                mail: "",
                gender: "",
                name: "",
                lastname: "",
                password: "",
                dni: "",
                roles: ["end_user"],
                dob: "",
                active: true,
                deceased: false,
                street: "",
                subdivision: "",
                insuranse: "",
                telefono: "",
                city: "",
                robot: false
            };
            
            // Asignar los nuevos datos
            if (data && typeof data === 'object') {
                Object.keys(data).forEach(key => {
                    if (data[key] !== undefined && data[key] !== null) {
                        this.$set(this.account_info, key, data[key]);
                    }
                });
            }
            
            // Actualizar campos de confirmación
            this.mail_confirm = this.account_info.mail || '';
            this.pass_confirm = this.account_info.password || '';
            this.normalizeInsuranceSelection();
        },

        normalizeInsuranceSelection() {
            const currentValue = this.account_info.insuranse;

            if (currentValue === null || currentValue === undefined || currentValue === '') {
                return;
            }

            if (!Array.isArray(this.insuranseOptions) || this.insuranseOptions.length === 0) {
                return;
            }

            const normalizedValue = typeof currentValue === 'object'
                ? (currentValue.value ?? currentValue.id ?? currentValue.name)
                : currentValue;

            const selectedOption = this.insuranseOptions.find(option => {
                return String(option.value) === String(normalizedValue) || String(option.name) === String(normalizedValue);
            });

            if (selectedOption) {
                this.account_info.insuranse = selectedOption.value;
                return;
            }

            this.account_info.insuranse = normalizedValue;
        },

        async validateForm(){
            this.$v.$touch()

            
            if (this.$v.$invalid) {

                return
            }
          

            
            if (this.captcha){
                
                if (this.account_info.robot){

                   this.$emit('account_info_from_child',this.account_info)
                }
                                else{
                                    await this.$alert({ title: 'Validación requerida', message: 'Complete el casillero No soy robot', color: 'warning' });
                                }
              }
              else {

                  this.$emit('account_info_from_child',this.account_info)
              }   
        },
        async search(){
            let dataPatient = await getPacienteData(false, this.account_info.dni)
        
            if (dataPatient==404){
                await this.$alert({ title: 'No encontrado', message: 'Usuario NO ENCONTRADO, DEBE INGRESARLO', color: 'warning' });
            }
            else{
                this.insert_data_paciente(dataPatient)
            }
        },
        insert_data_paciente(dataResponse){
            //let dataResponse = await get_paciente_data(this.$store.state.credentials.thalamus_server, this.account_info)
            
            
            let data =dataResponse[0];
            let direccion = dataResponse[1]
            let contacto = dataResponse[2]
            let usuario = dataResponse[3]
            
            //this.loadDataPatient(response.data);
            /*if (data.party.gender=='m'){
                this.genero="Masculino";
            }
            else{
                this.genero="Femenino";
            }*/
            this.account_info.gender=data.party.gender
            //this.account_id=this.$store.state.credentials.fedacct
            this.account_info.dni=data.party.ref;
            this.account_info.name=data.party.name;
            this.account_info.lastname=data.party.lastname;
            //this.account_info.password=this.$store.state.credentials.password;
            //this.pass_confirm=this.$store.state.credentials.password
            if (JSON.stringify(usuario)!='{}'){
               
                if(usuario)
                    this.account_info.mail=usuario.email
            }
            
            this.account_info.dob=data.party.dob;
            if(data.seguro)
                this.account_info.insuranse=data.seguro.empresa.id;
            
            if (JSON.stringify(direccion)!='{}'){
                this.account_info.street=direccion.street;
                this.account_info.city=direccion.city;
                //this.provincias.value=direccion.provincia.id;
                this.account_info.subdivision=direccion.provincia.id
            }
            if (JSON.stringify(contacto)!='{}'){
                this.account_info.telefono=contacto.value;
            }
        },
        resetData(){
            this.account_info= {
            gender:"",
            name: "",
            lastname: "",
            password: "" ,
            dni:"",
            dob: "",
            active: true,
            city:"",
            street:"",
            subdivision:"",
            insuranse:  "",
            telefono:"",
            mail: "",
            }
        },
        async iniciar_datos(){
          let data = await initial_data(this.$default_thalamus_server)
 
                    this.insuranseOptions=data.insuranse || []
                    this.provincias=data.provincias || []
                    this.normalizeInsuranceSelection();
        },
        // createRecaptcha () {
        //     // Temporarily disabled due to Vue 3 compatibility issues
        //     let script = document.createElement('script')
        //     script.id = 'recaptchaScript'
        //     script.src = 'https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit'
        //     script.setAttribute('async', '')
        //     script.setAttribute('defer', '')
        //     document.head.appendChild(script);
        // },
        // // remove
        // removeRecaptcha () {
        //     document.getElementById('recaptchaScript').remove()
        // },
        // onVerify: function (response) {
        //     if (response) this.account_info.robot = true;
        // },
    },
    created(){
      // Inicializar account_info si no está definido
      if (!this.account_info || Object.keys(this.account_info).length === 0) {
        this.account_info = {
          mail: "",
          gender: "",
          name: "",
          lastname: "",
          password: "",
          dni: "",
          roles: ["end_user"],
          dob: "",
          active: true,
          deceased: false,
          street: "",
          subdivision: "",
          insuranse: "",
          telefono: "",
          city: "",
          robot: false
        };
      }
      
      this.iniciar_datos()
      // this.createRecaptcha() // Temporarily disabled
    },

    // beforeDestroy () {
    //     this.removeRecaptcha() // Temporarily disabled
        
    // },
  
}
</script>